import { useEffect } from 'react';

// SmoothScroll disabled - using native browser scroll for better mouse wheel support
export const SmoothScroll = ({ children }) => {
  return <>{children}</>;
};
